var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { DataListHeaderRow } from './DataListHeaderRow';
import { DataListHeaderCell, } from './DataListHeaderCell';
import { DataListRow } from './DataListRow';
import { DataListCell } from './DataListCell';
export const DataList = (_a) => {
    var { children, className, header, items, spacing = 2, simple } = _a, rest = __rest(_a, ["children", "className", "header", "items", "spacing", "simple"]);
    const generateRows = (header, items) => {
        const actualheader = Array.isArray(header)
            ? header
            : [header];
        const headersProperties = actualheader.map((headerCell) => headerCell.props);
        const rows = items.map((item, index) => {
            return (React.createElement(DataListRow, { key: index }, generateCells(item, headersProperties)));
        });
        return rows;
    };
    const generateCells = (item, headersProperties) => {
        return headersProperties.map((headerProperties, index) => {
            const { name, children, className } = headerProperties, cellProperties = __rest(headerProperties, ["name", "children", "className"]);
            return (React.createElement(DataListCell, Object.assign({ key: index }, cellProperties), item[headerProperties.name]));
        });
    };
    const classes = classnames('DataList', className, `DataList--spacing-${spacing}`, {
        'DataList--Simple': simple,
    });
    const headerRow = (React.createElement(DataListHeaderRow, null, header));
    const rows = children || generateRows(header, items);
    return (React.createElement("div", Object.assign({ className: classes, "data-anvil-component": "DataList" }, rest),
        headerRow,
        rows));
};
DataList.HeaderRow = DataListHeaderRow;
DataList.HeaderCell = DataListHeaderCell;
DataList.Row = DataListRow;
DataList.Cell = DataListCell;
//# sourceMappingURL=DataList.js.map